import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { CallbackComponent } from "redux-oidc";
import userManager from "../../utils/userManager";


class CallbackPage extends React.Component {
    render() {
        // just add code to redirect to '/' in both cases
        return (
            <div>
                <CallbackComponent
                    userManager={userManager}
                    successCallback={(user) => {                       
                        this.props.history.push("/");

                        // here we can look at the user and send them to an access denied component
                        // if they are not in the access group.
                    }
                    }
                    errorCallback={error => {
                        console.error(error);
                    }}
                >
                    <div>Redirecting...</div>
                </CallbackComponent>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
      
    };
}


export default withRouter(connect(null,mapDispatchToProps)(CallbackPage));